// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__3YnrM","loader__inner":"loader_loader__inner__TtzNC","ripples":"loader_ripples__2qjET","loader__inner--delay":"loader_loader__inner--delay__3fQoJ"};